import { get_token} from "@/router";

export default {
  name: 'DiscussionTopic',
  props: {
      discussion: {
            type: Map,
        },
  },
  data() {
    return ({
      comments: [],
      show_reply_input: false,
      reply_text: '',
      reply_comment_id:null
    });
  },
  mounted() {
    this.show_modal();
    this.fetch_comments();
  },
  methods: {
    getToken() {
        return get_token();
        },
    fetch_comments() {
      // Replace with your actual API endpoint and logic
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_comments_for_topic/`,
        method: 'POST',
        data: JSON.stringify({
          topic_id: this.discussion.id,
        }),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          this.comments = response.data;
        },
        error: (err) => {
          console.error('Failed to fetch comments', err);
        }
      });
    },
    post_comment() {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/post_comment/`,
        method: 'POST',
        data: JSON.stringify({
          topic_id: this.discussion.id,
          comment_text: this.comment_text,
        }),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          this.comments.unshift(response.data);
          this.comment_text = '';
        },
        error: (err) => {
          console.error('Failed to fetch comments', err);
        }
      });
    },
    reply_to_comment(comment_id) {
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/reply_to_comment/`,
            method: 'POST',
            data: JSON.stringify({
              topic_id: this.discussion.id,
              comment_id:comment_id,
              reply_text: this.reply_text,
            }),
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
            success: () => {
               this.reply_text = '';
               this.show_reply_input = false;
               this.reply_comment_id = null;
               this.fetch_comments();
            },
            error: (err) => {
              console.error('Failed to fetch comments', err);
            }
          });
        },
    show_modal() {
        $("#comment_modal").modal("show");
    },
    hide_modal(){
      $("#comment_modal").modal("hide");
      this.$emit('hide_comment')
    },
    time_ago(dateStr) {
    const date = new Date(dateStr);
    const now = new Date();
    const diff_mss = now - date;
    const diff_sec = Math.floor(diff_mss / 1000);
    const diff_min = Math.floor(diff_sec / 60);
    const diff_hour = Math.floor(diff_min / 60);
    const diff_day = Math.floor(diff_hour / 24);

    if (diff_min < 1) return 'just now';
    if (diff_min < 60) return `${diff_min} minute${diff_min === 1 ? '' : 's'} ago`;
    if (diff_hour < 24) return `${diff_hour} hour${diff_hour === 1 ? '' : 's'} ago`;
    if (diff_day < 7) return `${diff_day} day${diff_day === 1 ? '' : 's'} ago`;

    // Fallback to formatted date: 13 February 2025
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    return date.toLocaleDateString(undefined, options);
  }
  }
};